import styles from './ThemeTags.module.css';

interface Props {
  themes: string[];
}

function abbreviate(name: string): string {
  return name
    .replace('Products & Services', 'P&S')
    .replace('& Circular Economy', '')
    .replace('& Storage', '')
    .replace('Environmental ', 'Env. ');
}

export function ThemeTags({ themes }: Props) {
  if (!themes || themes.length === 0) return null;
  return (
    <div className={styles.root}>
      {themes.map((t) => (
        <span key={t} className={styles.tag}>
          {abbreviate(t)}
        </span>
      ))}
    </div>
  );
}
